import {useEffect, useState} from 'react';
import {useFeatureService} from './use-feature-service';
import {CommonFeatureServices} from '../contexts/feature-app-environment-context';
import {findTrim} from './get-selected-trim';
import {EmbeddedAppSharedData} from '../types';
import {BffTrimData} from '@volkswagen-onehub/whitelabel-e-mobility-data-types';
import {useIsNestedFeatureApp} from './use-is-nested-feature-app';

export function useSharedEmbeddedFeatureAppData<T>(
  trims: BffTrimData<T>[],
  onChangeModel: (newValue: string, shared?: boolean) => void
) {
  const [sharedData, setSharedData] =
    useState<EmbeddedAppSharedData | undefined>(undefined);
  const layerButtonCustomChannel = useFeatureService(
    CommonFeatureServices.layerButtonChanelService
  );
  const isNestedFeatureApp = useIsNestedFeatureApp();

  useEffect(() => {
    if (!layerButtonCustomChannel || !isNestedFeatureApp) return;

    const {client} = layerButtonCustomChannel;
    client.listen(setSharedData);

    const sharedModel = client.get();
    if (sharedModel?.modelTypeId) {
      const trim = findTrim<T>(trims, sharedModel.modelTypeId);
      if (trim) {
        setSharedData(sharedModel);
        onChangeModel(sharedModel.modelTypeId, true);
      }
    }
  }, [
    layerButtonCustomChannel,
    layerButtonCustomChannel?.client,
    trims,
    sharedData,
    onChangeModel,
  ]);
}
